import { createContext, useContext, useState, useRef, useEffect, useCallback } from "react";
import { useEmployee } from "../../../providers/EmployeeProvider";
import { useDispatch } from "react-redux";
import { NAVIGATION_OPEN } from "../../../store/actions";


export const NavigationContext = createContext();

export const useNavigation = () => useContext(NavigationContext);

export const NavigationProvider = (props) => {
  const { destination, metadata, onReady, onCancel } = props;

  const [loaded, setLoaded] = useState(false);
  const [navCore, _setNavCore] = useState(null);
  const containerRef = useRef(null);
  const { updateVehicle } = useEmployee();
  const [suggestedDestination, setSuggestedDestination] = useState(null);

  const updateVehicleRef = useRef(updateVehicle);
  updateVehicleRef.current = updateVehicle;

  const onCancelRef = useRef(onCancel);
  onCancelRef.current = onCancel;

  useEffect(() => {
    if (!!suggestedDestination) {

      navCore?.renderer.setSuggestion(suggestedDestination);

      return () => {
        navCore?.renderer?.removeSuggestion();
      }
    }

  }, [suggestedDestination, navCore]);
  
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch({ type: NAVIGATION_OPEN, payload: true });
    return () => {
      dispatch({ type: NAVIGATION_OPEN, payload: false });
    };
  }, [dispatch]);

  const setNavCore = useCallback((nc) => {
    _setNavCore(nc);

    if (typeof onReady === "function") {
      onReady(nc);
    }
  }, [onReady]);

  const [_destination, _setDestination] = useState(null);
  const [geolocationError, setGeolocationError] = useState(false);

  const { vehicleDetails } = useEmployee();
  const [centered, setCentered] = useState(false);

  const refMetadataData = useRef(metadata);
  refMetadataData.current = metadata;
  const refVehicleData = useRef(vehicleDetails);
  refVehicleData.current = vehicleDetails;

  const setDestination = useCallback((loc) => {
    if (!!navCore) {
      _setDestination(loc);
      navCore.setDestination(loc, refVehicleData?.current, refMetadataData?.current);
    }
  }, [navCore]);

  useEffect(() => {
    if (!!navCore && !!destination && destination?.coordinates?.length === 2) {
      _setDestination(destination);
      navCore.ready().then(() => navCore.setDestination(destination, refVehicleData?.current, refMetadataData?.current));
    }
  }, [navCore, destination]);

  const cancel = useCallback(() => {
    updateVehicleRef.current?.({ routingData: null }, ["routingData"]);
    _setDestination(null);

    if (typeof onCancelRef.current === "function") {
      onCancelRef.current();
    }

  }, []);

  const onRouteReported = useCallback((routingData) => {
    updateVehicleRef.current?.({ routingData }, ["routingData"]);
  }, []);

  const onDestroy = useCallback(() => {
    updateVehicleRef.current?.({ routingData: null }, ["routingData"]);
  }, []);

  return (
    <NavigationContext.Provider
      value={{
        containerRef,
        loaded,
        setLoaded,
        navCore,
        setNavCore,
        setDestination,
        destination: _destination,
        cancel,
        hasDestination: !!_destination,
        geolocationError,
        setGeolocationError,
        centered,
        setCentered,
        vehicleDetails,
        onRouteReported,
        onDestroy,
        suggestedDestination, 
        setSuggestedDestination
      }}
    >
      {props.children}
    </NavigationContext.Provider>
  );
};

